export const toUserInfos = session => ({
  mail: session.email,
  employeeNumber: session.employeeNumber,
  displayName: session.name,
  employeeType: session.attributes.employeeType,
  site: session.site
})
